/* eslint-disable max-len,no-undef,react/prop-types,no-console */
import React from 'react';
import { graphql } from 'gatsby';
import axios from 'axios';
import firebase from 'firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { CHECK_USER_EMAIL_SUBSCRIBED } from '../api/customer/routes';
import UnitedKingdomIcon from '../images/icons/united-kingdom.svg';
import SEO from '../components/seo';
import './style.scss';
import Layout from '../components/Layout';
import NavBar from '../components/NavBar';
import HeroSwiper from '../components/HeroSwiper';
import ProductCategorySelector from '../components/ProductCategorySelector';
import HomeIntro from '../components/HomeIntro';
import SubscribeMailingList from '../components/SubscribeMailingList';
import Footer from '../components/Footer';
import DrWatsonLargeLogo from '../components/DrWatsonLargeLogo';
import getCloudinary from '../utils/getCloudinary';
import SubscriptionModal, { SUBSCRIPTION_MODAL } from '../components/SubscriptionModal';
import { checkIfFirebaseAuthMagicLink } from '../utils/firebaseAuth';
import StockistFinderFeature from '../components/StockistFinderFeature';

let USER_EMAIL_CHECKED = false;
const IndexPage = ({ data }) => {
    const [userAlreadySubscribed, setUserAlreadySubscribed] = React.useState(true);
    // eslint-disable-next-line no-unused-vars
    const [authUser, userInitialising, userError] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);

    console.log('A');
    React.useEffect(() => {
        console.log('B');
        if (!userInitialising && !USER_EMAIL_CHECKED) {
            console.log('C');
            USER_EMAIL_CHECKED = true;
            axios
                .get(
                    CHECK_USER_EMAIL_SUBSCRIBED
                        .replace('{email}', authUser && authUser.email),
                )
                .then((userAlreadySubscribedResponse) => {
                    if (userAlreadySubscribedResponse) {
                        setUserAlreadySubscribed(userAlreadySubscribedResponse.data.result);
                    }
                })

                .catch(
                    (error) => {
                        // eslint-disable-next-line no-console
                        console.log('error');
                        // eslint-disable-next-line no-console
                        console.log(error);
                    },
                );
        }

        checkIfFirebaseAuthMagicLink();
    });


    // eslint-disable-next-line no-console
    console.log(data);

    const expirationDuration = 1000 * 60 * 60 * 24 * 7;

    let prevAccepted = null;
    if (typeof window !== 'undefined') {
        prevAccepted = localStorage.getItem(SUBSCRIPTION_MODAL);
    }
    const currentTime = new Date().getTime();

    const notAccepted = !prevAccepted;
    const prevAcceptedExpired = prevAccepted !== undefined && currentTime - prevAccepted > expirationDuration;
    const showSubscriptionModal = (notAccepted || prevAcceptedExpired)
        && !userAlreadySubscribed
        && parseInt(Math.random() * 10, 10) / 2 < 2; // Add some randomness so it does not spam user

    return (
        <Layout className="home-page">
            <SEO
                title="DR WATSON – Buy Best CBD Products Online UK - 100% Lab Tested"
                description="Buy high-quality CBD Products such as CBD pods, e-liquids, body lotion, face cream, CBD oil and supplements from our online store in the UK. ✔ High-Quality ✔ Certified Suppliers ✔ Lab Tested."
            />
            <DrWatsonLargeLogo />
            <NavBar />
            <div className="nav-bar-below-content">
                <HeroSwiper />
                <ProductCategorySelector />

                <div className="lifestyle-image is-marginless">
                    <div className="main-overlay-content">
                        <img
                            className="ace-pocket-image"
                            src={
                                getCloudinary().url(
                                    'dashboard-uploads/ace-pocket_p6efiq',
                                    { height: 850, crop: 'fit', fetch_format: 'auto' },
                                )
                            }
                            alt="CBD Delivery System next to planning diary"
                        />
                        <div className="image-dimmer" />
                        <div className="main-text">
                            <div className="title is-size-4-touch is-size-3-desktop is-spaced has-text-white">
                                Dr Watson CBD Pod System
                            </div>

                            <div className="subtitle is-size-6-touch is-size-4-desktop has-text-white">
                                The easiest way to take your CBD on the go. No more chunky devices, this smooth device
                                slides right into your pocket.

                                <br />
                                <br />

                                Available in 5 amazing terpene rich flavours in ~2ml pods with 240mg (6%) of CBD per
                                pack of pods.

                                <br />
                                <br />

                                E-liquid made using GMP Certified Hemp from partner farms in the US

                                <br />
                                <br />

                                <div className="made-in-uk-container is-flex">
                                    <img src={UnitedKingdomIcon} alt="Made in UK" className="uk-icon" />
                                    <span className="subtitle is-size-5-touch is-size-4-desktop has-text-white">Made in the UK</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <HomeIntro />

                <StockistFinderFeature />

                {/* <FeaturedProducts */}
                {/*    title="CBD Pods" */}
                {/*    subtitle="5 Flavours in 2 x 2ml pods" */}
                {/*    productType={PODS} */}
                {/*    description="The DR WATSON proprietary pod system has a selection of 5 unique flavours with spins on a number of popular fruits and plants. Each pod pack contains 240mg (6%) of CBD and are made with natural terpenes for effect. There's no need to be filling vape anymore, just pop your favourite flavour into your Dr Watson device and you're good to go." */}
                {/*    products={ */}
                {/*        data.allStrapiProduct.edges.map( */}
                {/*            ({ node }) => node, */}
                {/*        ).filter(product => product.productgroup.name === PODS) */}
                {/*    } */}
                {/* /> */}
                {/* <FeaturedProducts */}
                {/*    title="CBD E-Liquids" */}
                {/*    subtitle="6 Premium CBD Flavours" */}
                {/*    productType={E_LIQUIDS} */}
                {/*    description="Our CBD E-liquids have been blended to perfection after months of development. They are all made with natural cannabis terpenes and from other plants. We have flavours that have taken inspiration from strains of the plant and regular flavours that will appeal to all." */}
                {/*    products={ */}
                {/*        data.allStrapiProduct.edges.map( */}
                {/*            ({ node }) => node, */}
                {/*        ).filter(product => product.productgroup.name === E_LIQUIDS) */}
                {/*    } */}
                {/* /> */}
                <SubscribeMailingList />
                <Footer />

                {
                    showSubscriptionModal && (
                        <SubscriptionModal />
                    )
                }
            </div>
        </Layout>
    );
};


export const query = graphql`
    query {
        allStrapiProduct {
            edges {
                node {
                    name
                    description
                    slug
                    productgroup {
                        name
                    }
                    variants {
                        name
                        description
                        price
                        wholesale_price
                        isFeatured
                        images {
                            createdAt
                            url
                            public_id
                        }
                    }
                }
            }
        }
    }
`;

export default IndexPage;
